export const commoditys = [
    {
        title: '水晶畫',
        desc1: '水晶般剔透折射 新奇影像體驗',
        desc2: '讓相片更顯色彩 更明亮',
    },
    {
        title: '沖洗照片',
        desc1: '超低三元平價好質感',
        desc2: '畫質提升'
    },
    {
        title: '絲絨無框畫',
        desc1: '超輕量 可直接黏貼',
        desc2: '免釘子 牆壁不打洞'
    },
    {
        title: '相片書系列',
        desc1: '延續旅行、生活的溫度',
        desc2: '創作專屬書名'
    },
    {
        title: '桌曆系列',
        desc1: '預約一整年的幸福',
        desc2: '珍珠、雪銅版面任選'
    },
    {
        title: '似顏無框畫',
        desc1: '把照片變成Q版人像',
        desc2: '多種畫風供您選擇'
    },
]